import React from 'react';

import styles from './RedTooltip.scss';
import tooltipImg from './img/tooltip_red.png';
import closeImg from './img/close_icon.gif';
import buttons from './Button.scss';


function showTooltip(name) {
	closeTooltips();
	document.getElementById(name).classList.add(styles.visible)
}

function closeTooltips() {

	const elems = document.getElementsByClassName(styles.container);
	[].forEach.call(elems, function (el) {
		el.classList.remove(styles.visible);
	});

}

const RedTooltip = ({title, tooltip, name}) => {

	return (
		<div id={name} className={styles.container}>
			<button className={`${buttons.buttonImage}`}
					onClick={() => showTooltip(name)}>
				<img src={tooltipImg} alt={title} title={title}/>
			</button>
			<div className={styles.tooltip}>
				<div>
					<div data-layout='text-right'>
						<button className={`${buttons.buttonImage}`}
								onClick={closeTooltips}>
							<img src={closeImg} alt={'Close'} title={'Close'}/>
						</button>
					</div>
					{tooltip}
				</div>
			</div>
		</div>
	)
};

export default RedTooltip;